import { call, put } from "redux-saga/effects";
import Axios from "../../utils/axios";
import { VERIFY_ACCOUNT_BY_TOKEN } from "../../state/user/constants";
import {
  verifyUserTokenDone,
  verifyUserTokenError
} from "../../state/user/actions";

function* verifyUserToken({ token }) {
  try {
    const result = yield call(Axios.core.post, VERIFY_ACCOUNT_BY_TOKEN, {
      token
    });
    yield put(verifyUserTokenDone(result?.data));
  } catch (e) {
    yield put(verifyUserTokenError(e?.response));
  }
}

export default verifyUserToken;
